import './background.scss';

function Background() {
    return (
        <div className="forgot-backdrop">
        </div>
    );
};

export default Background;